import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import {AuthService} from "../../../service/auth.service";

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  console.log('Login Guard - Is Authenticated:', authService.isAuthenticated());

  if (authService.isAuthenticated()) {
    console.log('User is authenticated, redirecting to dashboard');
    router.navigate(['/dashboard']);
    return false;
  }

  console.log('User is not authenticated, allowing access to login');
  return true;
};
